import {
    GA_DIMENSION_BOT_PRESET,
    GA_DIMENSION_PUSH_PRESET,
    GA_DIMENSION_PWA_PRESET,
} from 'App/constants';

/**
 * Creates the three GameAnalytics custom-dimension slots used by game LPs.
 * A fresh object keeps each landing's runtime configuration isolated.
 */
export const createGameAnalyticsDimensions = () => ({
    values1: {
        preset: GA_DIMENSION_PUSH_PRESET,
        current: '',
    },
    values2: {
        preset: GA_DIMENSION_PWA_PRESET,
        current: '',
    },
    values3: {
        preset: GA_DIMENSION_BOT_PRESET,
        current: '',
    },
});
